import _isFinite from "lodash/isFinite";
import React from 'react';
import classnames from 'classnames';
import Debounce from 'react-debounce-component';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import cn from 'classnames';
import ItemTitle from 'swag-client-common/components/partials/item-title';
import { QuantityPerSize } from 'swag-client-common/components/partials/quantity-per-size';
import { Price } from 'swag-client-common/utils/price';
import css from '../../content.scss';
import anim from '../../../select-cart-items-header/fast-appear.anim.scss';
import { sizeItemClassNameList, sizeItemInputClassNameList, sizeItemInputLabelNameList, sizeItemInputWrapperClassNameList } from '../card-item.utils';
export const ProductInfoBlockComponent = ({
  variant,
  productName,
  quantityPerBox,
  itemPriceValue,
  errorText,
  productIsAlwaysInStock,
  sizes,
  quantitiesItem,
  isQtyError,
  totalCount,
  totalSizesQuantity,
  isSelected,
  onChangeHowManyInEachBox,
  onQuantityPerSizeChange,
  onQuantityInCart,
  handleSelectItem,
  quantityInCartLabel,
  quantityInCartValue
}) => {
  const transformedItemPriceValue = Price.formatNumber(itemPriceValue);
  const sizeItemClassName = sizeItemClassNameList[(sizes === null || sizes === void 0 ? void 0 : sizes.length) || '1'];
  const sizeItemInputClassName = classnames(css.inputQuantityPerSize, sizeItemInputClassNameList[(sizes === null || sizes === void 0 ? void 0 : sizes.length) || '1']);
  const sizeItemLabelClassName = sizeItemInputLabelNameList[(sizes === null || sizes === void 0 ? void 0 : sizes.length) || '1'];
  const sizeItemInputWrapperClassName = sizeItemInputWrapperClassNameList[(sizes === null || sizes === void 0 ? void 0 : sizes.length) || '1'];
  return /*#__PURE__*/React.createElement("div", {
    className: css.cardInfoWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: css.cardInfoContentWrapper,
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement("div", {
    className: css.cardInfoContent
  }, /*#__PURE__*/React.createElement(ItemTitle, {
    productName: productName,
    productNameClass: css.productNameClass
  }), /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: anim,
    key: `${quantityInCartLabel}${quantityInCartValue}`,
    timeout: 250
  }, /*#__PURE__*/React.createElement("span", {
    className: css.quantity
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, quantityInCartLabel), /*#__PURE__*/React.createElement("span", {
    onClick: () => {
      onQuantityInCart();
    },
    className: cn(css.quantityValue, {
      [css.qtyError]: isQtyError,
      [css.qtyDisabled]: !isSelected
    }),
    "data-text": "ProductQuantity",
    "data-ignore-selection": "1"
  }, quantityInCartValue))))), /*#__PURE__*/React.createElement("div", {
    className: css.inEachBoxLine
  }, /*#__PURE__*/React.createElement("span", {
    className: css.inEachBoxText
  }, "Quantity in each box?"), /*#__PURE__*/React.createElement("input", {
    "data-input": "QuantityPerBox",
    type: "text",
    value: quantityPerBox,
    onFocus: handleSelectItem,
    onChange: e => {
      const val = Number(e.target.value);
      if (Number.isNaN(val) || val < 0 || val > 99) {
        return;
      }
      onChangeHowManyInEachBox(val);
    },
    className: cn(css.pink, css.howManyInEachBoxCol)
  }), /*#__PURE__*/React.createElement("span", {
    className: css.inEachBoxTotal
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: anim,
    key: totalCount || 0,
    timeout: 250
  }, /*#__PURE__*/React.createElement("span", {
    "data-text": "ProductTotal"
  }, "(Total in box: ", totalCount || 0, ")"))))), !!sizes && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuantityPerSize, {
    productIsAlwaysInStock: productIsAlwaysInStock,
    sizes: sizes,
    variant: variant,
    quantities: quantitiesItem,
    sizeContainerClassName: css.sizeContainerClassName,
    sizeItemClassName: sizeItemClassName,
    sizeItemInputClassName: sizeItemInputClassName,
    sizeItemInputWrapperClassName: sizeItemInputWrapperClassName,
    sizeItemLabelClassName: sizeItemLabelClassName,
    onFocus: handleSelectItem,
    onChange: ({
      value,
      sizeIndex
    }) => {
      if (String(value).length >= 7) {
        return null;
      }
      const newQuantities = [...quantitiesItem];
      newQuantities[sizeIndex] = value;
      onQuantityPerSizeChange(newQuantities);
    }
  }))), /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    key: `${errorText || ''}_${totalSizesQuantity || ''}`,
    timeout: 255,
    classNames: anim
  }, /*#__PURE__*/React.createElement(Debounce, null, /*#__PURE__*/React.createElement("div", {
    className: css.underSizesBlock
  }, _isFinite(totalSizesQuantity) && /*#__PURE__*/React.createElement("span", {
    "data-text": "totalSizesQuantity",
    className: css.totalSizesQuantity
  }, `(All sizes: ${totalSizesQuantity})`, "\xA0"), /*#__PURE__*/React.createElement("span", {
    "data-text": "Error",
    className: css.errorText
  }, errorText)))))), /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: anim,
    key: transformedItemPriceValue || 0,
    timeout: 250
  }, /*#__PURE__*/React.createElement("div", {
    className: css.price
  }, /*#__PURE__*/React.createElement("span", {
    className: css.priceText
  }, "Item price:"), /*#__PURE__*/React.createElement("span", {
    className: css.priceValue,
    "data-text": "ItemPrice"
  }, "\xA0", transformedItemPriceValue || 0)))));
};